// extracted by mini-css-extract-plugin
export default {"external":"aze0LK","wrapper":"bze0LK","block":"cze0LK","assetName":"dze0LK"};